// extracted by mini-css-extract-plugin
export default {"container":"SmallImageCard_container__DPpUU","container__overBlock":"SmallImageCard_container__overBlock__bJ9Fl"};